import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("ot_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  const opId = localStorage.getItem("dbs_active_operator");
  if (opId) config.headers["X-Operator-Id"] = opId;
  return config;
});

// Helpers to change the active operator app-wide.
export const OPERATOR_STORAGE_KEY = "dbs_active_operator";
export const OPERATOR_EVENT = "dbs-operator-changed";
export const OPERATORS_LIST_CHANGED = "dbs-operators-list-changed";
export function setActiveOperator(id) {
  if (id) localStorage.setItem(OPERATOR_STORAGE_KEY, id);
  else localStorage.removeItem(OPERATOR_STORAGE_KEY);
  window.dispatchEvent(new CustomEvent(OPERATOR_EVENT, { detail: id || null }));
}
export function getActiveOperator() {
  return localStorage.getItem(OPERATOR_STORAGE_KEY) || null;
}
export function notifyOperatorsChanged() {
  window.dispatchEvent(new CustomEvent(OPERATORS_LIST_CHANGED));
}

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem("ot_token");
      localStorage.removeItem("ot_user");
      if (!window.location.pathname.includes("login")) window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

export const formatError = (e) => {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Erro desconhecido";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x.msg || JSON.stringify(x)).join(" ");
  return JSON.stringify(d);
};

export const formatCurrency = (v) =>
  (v ?? 0).toLocaleString("pt-PT", { style: "currency", currency: "EUR" });

export const formatDate = (iso) => {
  if (!iso) return "-";
  try {
    return new Date(iso).toLocaleString("pt-BR", {
      day: "2-digit", month: "2-digit", year: "numeric",
      hour: "2-digit", minute: "2-digit"
    });
  } catch { return iso; }
};

export const formatDateOnly = (iso) => {
  if (!iso) return "-";
  try {
    return new Date(iso).toLocaleDateString("pt-BR");
  } catch { return iso; }
};
